"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityButton = exports.CardContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = require("@kyruus/button");
exports.CardContainer = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('alt_provider_profile_border_radius')};
`;
exports.AvailabilityButton = (0, styled_1.default)(button_1.ButtonLink) `
  width: 100%;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  text-align: center;
  vertical-align: bottom;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  align-self: end;

  > span.button-text {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  }
`;
//# sourceMappingURL=MiniProviderCard.styles.js.map